<div class="question-type-survey-descriptive-wrapper">
  <div class="form-group">
    <p [innerHtml]="sanitizer.bypassSecurityTrustHtml(descriptiveQuestion)"></p>
    <textarea class="form-control" rows="4" placeholder="{{'items.placeholderAns' | translate}}" 
    readonly></textarea>
  </div>
</div>
